import React, { useState } from "react";
import { FaEnvelopeOpenText } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./NovedadCard.css";

const NovedadCard = ({
  data,
  onConsultaClick,
  prev,
  next,
  onSelect,
  novedadesList,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const soloPrev = prev && !next;
  const soloNext = next && !prev;
  const ambos = prev && next;

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setError("");
    setTermsAccepted(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setError("Por favor, ingresa un email válido.");
      return;
    }

    if (!termsAccepted) {
      setError("Debes aceptar los términos y condiciones antes de enviar.");
      return;
    }

    setIsLoading(true);
    setError("");

    const emailParams = {
      from_name: formData.fullName,
      from_email: formData.email,
      message: formData.message,
    };

    const serviceID = "thorne-mail-sender";
    const templateID = "contact_form_thorne";
    const userID = "user_s4ksp8kthXIPpoKDWLJp9";

    emailjs
      .send(serviceID, templateID, emailParams, userID)
      .then(() => {
        setIsModalOpen(false);
        setFormData({ fullName: "", email: "", message: "" });
        setTermsAccepted(false);

        setTimeout(() => {
          const link = document.createElement("a");
          link.href = data.archivoUrl;
          link.download = data.archivoNombre;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }, 500);
      })
      .catch((error) => {
        console.error("Error al enviar el mensaje:", error);
        setError("Ocurrió un error al enviar el mensaje, intenta nuevamente.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="novedad-card-container">
      {/* Dropdown selector */}
      {novedadesList?.length > 1 && (
        <div className="novedades-dropdown-wrapper">
          <button
            className="novedades-dropdown-button"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            {data.titulo}
            <span className="dropdown-arrow">{dropdownOpen ? "▲" : "▼"}</span>
          </button>

          {dropdownOpen && (
            <div className="novedades-dropdown-menu">
              {novedadesList.map((n) => (
                <div
                  key={n.id}
                  className={`novedad-titulo-selector ${
                    n.id === data.id ? "active" : ""
                  }`}
                  onClick={() => {
                    onSelect(n.id);
                    setDropdownOpen(false);
                  }}
                >
                  {n.titulo}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="novedad-card">
        <h2 className="novedad-card-title">{data.titulo}</h2>

        <div className="novedad-card-video">
          <video autoPlay muted playsInline controls>
            <source src={data.videoUrl} type="video/mp4" />
            Tu navegador no soporta videos HTML5.
          </video>
        </div>

        <p
          className="novedad-card-texto"
          dangerouslySetInnerHTML={{ __html: data.texto }}
        />

        <button className="novedad-card-descarga" onClick={toggleModal}>
          {data.archivoNombre}
        </button>

        <div className="novedad-btn-consulta-wrapper">
          <button className="novedad-btn-consulta" onClick={onConsultaClick}>
            Consulta
          </button>
        </div>

        <div
          className={`novedad-navegacion ${
            ambos
              ? "doble"
              : soloNext
              ? "solo-next"
              : soloPrev
              ? "solo-prev"
              : ""
          }`}
        >
          {prev && (
            <button
              onClick={() => onSelect(prev.id)}
              className="novedad-btn-nav izq"
            >
              ← Historia anterior
              <span className="novedad-sub">{prev.subtitulo}</span>
            </button>
          )}

          {next && (
            <button
              onClick={() => onSelect(next.id)}
              className="novedad-btn-nav der"
            >
              Historia siguiente →
              <span className="novedad-sub">{next.subtitulo}</span>
            </button>
          )}
        </div>
      </div>

      {/* Modal de contacto previo a descarga */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <FaEnvelopeOpenText className="modal-icon" />
            <h3 className="modal-title">Descarga el archivo</h3>

            {error && <p className="error-message">{error}</p>}

            <form className="contact-form" onSubmit={handleSubmit}>
              <label htmlFor="fullName">Nombre Completo</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Tu nombre completo"
                value={formData.fullName}
                onChange={handleChange}
                required
              />

              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Tu correo electrónico"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="message">Mensaje</label>
              <textarea
                id="message"
                name="message"
                rows="4"
                placeholder="Escribe tu mensaje aquí..."
                value={formData.message}
                onChange={handleChange}
                required
              />

              <div className="terms-container">
                <input
                  type="checkbox"
                  id="terms"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <label htmlFor="terms" className="terms-label">
                  <a
                    href="https://www.thorneglobalrealestate.com/terms-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Términos y condiciones
                  </a>
                </label>
              </div>

              <button
                type="submit"
                className="modal-submit-button"
                disabled={isLoading}
              >
                {isLoading ? "Enviando..." : "Enviar"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default NovedadCard;